import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
}

/**
 * SoundCheck brand mark.
 *
 * Renders the canonical SVG asset directly. Same vector source in light
 * and dark mode — no theme swapping, no rasterization, no filters.
 */
const SRC = "/lovable-uploads/soundcheck-logo.svg";

export const BrandLogo = ({
  className,
  width = 32,
  height = 32,
  alt = "SoundCheck Logo",
}: BrandLogoProps) => {
  return (
    <img
      src={SRC}
      alt={alt}
      width={width}
      height={height}
      decoding="sync"
      {...({ fetchpriority: "high" } as Record<string, string>)}
      draggable={false}
      className={cn("brand-logo block shrink-0 object-contain", className)}
      style={{ width, height }}
    />
  );
};

export default BrandLogo;
